import { changeToasterState, toggleModal } from '../../../Store/layoutSlice';
import { TOASTER_STATE } from '../../../Model/Enums';
import { useAppDispatch, useAppSelector } from '../../../Store/store';
import { useRevokeTokenMutation } from '../../../Store/client';
import { currentClientSelector } from '../../../Store/paramsBagSlice';

export const useRevokeTokenForm = () => {
  const dispatch = useAppDispatch();
  const currentClient = useAppSelector(currentClientSelector);

  const [revokeToken, { isLoading: inProgress }] = useRevokeTokenMutation();

  const revoke = async (event) => {
    event.preventDefault();

    try {
      await revokeToken({ clientId: currentClient?.clientId }).unwrap();
      await dispatch(changeToasterState(TOASTER_STATE.ACCESS_TOKEN_REVOKED_SUCCESS));
    } catch (e) {
      dispatch(changeToasterState(TOASTER_STATE.ACCESS_TOKEN_REVOKED_FAILED));
    } finally {
      await dispatch(toggleModal());
    }
  };

  return { inProgress, revoke };
};
